import Controller from "./listTable.controller";
import template from "./listTable.html";

const listTable = {
  template,
  controller: Controller,
  bindings: {
    items: "<",
    fields: "<",
    total: "<",
    page: "<",
    limit: "<",
    state: "<",
    stateName: "@",
    title: "@",
    paginateEvent: "<",
    sortEvent: "<",
    selectedSort: "<",
    selectedRowId: "<",
    noItemsText: "<",
    interceptorMsg: "<",
    isLoading: "<",
  },
};

export default listTable;



// WEBPACK FOOTER //
// ./src/components/listTable/listTable.component.js